export const HEADLINE_STYLES = 'm-0 font-suisse-works text-headline-sm font-medium';
export const MAGENTA = 'text-primary-magenta';
export const PARAGRAPH_STYLES = 'm-0 mt-16 font-suisse-intl text-body-lg';
export const PRO = 'Pro';
export const PRO_GOLD = 'text-pro-gold';
